import api from '@/libs/api'
import store from '@/store'

const organizationId = () => store.state.app.organizationId
const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    errors: [],
    projects: [],
    project: {},
    fetchingProjects: false,
    addingProject: false,
    gettingProject: false,
    updatingProject: false,
    users: [],
    user: {},
    usersResultInfo: {},
    usersCurrentPage: 1,
    fetchingUsers: false,
    invitingUser: false,
    gettingUser: false,
    updatingUser: false,
    removingUser: false,
    resultInfo: {},
    fetchingProjectByIdWithoutOrganization: false,
    projectWithoutOrganization: null,
  },
  getters: {
    selectedProject: state => state.project,
    usersCurrentPage: state => state.usersCurrentPage,
  },
  mutations: {
    SET_PROJECTS(state, data) {
      state.projects = data.result
      state.resultInfo = data.resultInfo
    },
    SET_FETCHING_PROJECTS(state, value) {
      state.fetchingProjects = value
    },
    GET_PROJECT(state, data) {
      state.project = data
    },
    SET_ADDING_PROJECT(state, value) {
      state.addingProject = value
    },
    SET_GETTING_PROJECT(state, value) {
      state.gettingProject = value
    },
    SET_UPDATING_PROJECT(state, value) {
      state.updatingProject = value
    },
    SET_PROJECT(state, project) {
      state.project = project
      const index = state.projects.findIndex(e => e.id === project.id)
      if (index > -1) state.projects[index].name = project.name
    },
    SET_USERS(state, data) {
      state.users = data.result
      state.usersResultInfo = data.resultInfo
    },
    GET_USER(state, user) {
      state.user = user
    },
    SET_INVITING_USER(state, value) {
      state.invitingUser = value
    },
    SET_FETCHING_USERS(state, value) {
      state.fetchingUsers = value
    },
    SET_GETTING_USER(state, value) {
      state.gettingUser = value
    },
    SET_UPDATING_USER(state, value) {
      state.updatingUser = value
    },
    SET_REMOVING_USER(state, value) {
      state.removingUser = value
    },
    REMOVE_USER(state, id) {
      state.users = state.users.filter(u => u.id !== id)
    },
    SET_FETCHING_PROJECT_BY_ID_WITHOUT_ORGANIZATION(state, value) {
      state.fetchingProjectByIdWithoutOrganization = value
    },
    SET_PROJECT_WITHOUT_ORGANIZATION(state, value) {
      state.projectWithoutOrganization = value
    },
    SET_USERS_CURRENT_PAGE(state, value) {
      state.usersCurrentPage = value
    },
  },
  actions: {
    fetchProjects({ commit }, query) {
      if (!query.returnOnly) {
        commit('SET_FETCHING_PROJECTS', true)
      }
      let endpoint = `/organizations/${query.organizationId ? query.organizationId : organizationId()}/projects?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`

      if (query.search) {
        endpoint += `&Search=${query.search}`
      }

      return new Promise((resolve, reject) => {
        api('captain').get(endpoint, { noSignalNeeded: true })
          .then(response => {
            if (!query.returnOnly) {
              commit('SET_PROJECTS', response.data)
            }
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            if (!query.returnOnly) {
              commit('SET_FETCHING_PROJECTS', false)
            }
          })
      })
    },
    addProject({ commit }, query) {
      commit('SET_ADDING_PROJECT', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .post(`/organizations/${organizationId()}/projects`, {
            name: query.name,
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_ADDING_PROJECT', false)
          })
      })
    },
    getProject({ commit }) {
      commit('SET_GETTING_PROJECT', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/projects/${projectId()}`, { noSignalNeeded: true })
          .then(response => {
            commit('GET_PROJECT', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_PROJECT', false)
          })
      })
    },
    setProject({ commit }, project) {
      commit('SET_UPDATING_PROJECT', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .put(`/projects/${projectId()}`, project)
          .then(response => {
            commit('SET_PROJECT', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_PROJECT', false)
          })
      })
    },
    inviteUser({ commit }, user) {
      commit('SET_INVITING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .post(`/projects/${projectId()}/users`, user)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_INVITING_USER', false)
          })
      })
    },
    fetchUsers({ commit }, payload) {
      let query = `/projects/${projectId()}/users?PageIndex=${
        payload.pageIndex
      }&PageSize=${payload.pageSize}`
      if (payload.search) {
        query += `&Search=${payload.search}`
      }
      commit('SET_FETCHING_USERS', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(query)
          .then(response => {
            commit('SET_USERS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_USERS', false)
          })
      })
    },
    getUser({ commit }, userId) {
      commit('SET_GETTING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/projects/${projectId()}/users/${userId}`)
          .then(response => {
            commit('GET_USER', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_GETTING_USER', false)
          })
      })
    },
    updateUser({ commit }, { userId, roleId }) {
      commit('SET_UPDATING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .put(`/projects/${projectId()}/users/${userId}`, { roleId })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_USER', false)
          })
      })
    },
    deleteUser({ commit }, userId) {
      commit('SET_REMOVING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .delete(`/projects/${projectId()}/users/${userId}`)
          .then(response => {
            commit('REMOVE_USER', userId)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_REMOVING_USER', false)
          })
      })
    },
    getProjectByIdWithoutOrganization({ commit }, projectIdInput) {
      commit('SET_FETCHING_PROJECT_BY_ID_WITHOUT_ORGANIZATION', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/projects/${projectIdInput}`, { noSignalNeeded: true })
          .then(response => {
            commit('SET_PROJECT_WITHOUT_ORGANIZATION', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_PROJECT_BY_ID_WITHOUT_ORGANIZATION', false)
          })
      })
    },
  },
}
